import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Volume2, VolumeX } from "lucide-react";

import {
    selectIsVoiceJourneyBgMuted,
    selectIsVoiceMuteButtonVisible,
    selectIsVoiceProcessing,
} from "../../../../store/features/ui/uiSelectors";

import { setIsVoiceJourneyBgMuted } from "../../../../store/features/ui/uiSlice";

import {
    startBackgroundTone,
    stopBackgroundTone,
} from "../../../../utils/backgroundTonePlayer";

export default function VoiceJourneyMuteUnmuteBgButton({
    isVoiceFlow,
    isVoiceFlowLocked,
}) {
    const dispatch = useDispatch();

    const isMuted = useSelector(selectIsVoiceJourneyBgMuted);
    const isVisible = useSelector(selectIsVoiceMuteButtonVisible);
    const isProcessing = useSelector(selectIsVoiceProcessing);

    const isVoiceActive = isVoiceFlow || isVoiceFlowLocked;
    const shouldShowButton = isVisible;
    // const shouldShowButton = isVisible && isVoiceActive;

    // console.log("VoiceJourneyMuteUnmuteBgButton Render:", {
    //     isMuted,
    //     isVisible,
    //     isProcessing,
    //     isVoiceActive,
    //     shouldShowButton,
    // });
    

    /**
     * 🎧 AUDIO CONTROLLER (ALWAYS ACTIVE)
     */
    useEffect(() => {
        if (shouldShowButton && isProcessing && !isMuted) {
            startBackgroundTone();
        } else {
            stopBackgroundTone();
        }

        return () => stopBackgroundTone();
    }, [shouldShowButton, isProcessing, isMuted]);

    // 👇 UI only, logic already ran
    if (!shouldShowButton) return null;

    // if (!isVoiceFlow) {
    //     return null;
    // }

    return (
        <button
            type="button"
            aria-label={isMuted ? "Unmute" : "Mute"}
            onClick={() => dispatch(setIsVoiceJourneyBgMuted(!isMuted))}
            className="
          absolute top-1/2 right-2 -translate-y-1/2
          p-2 rounded-full
          bg-white/70 dark:bg-black/40
          backdrop-blur
          hover:bg-gray-100 dark:hover:bg-white/10
          transition
          active:scale-95
        "
        >
            {isMuted ? (
                <VolumeX className="w-5 h-5 text-gray-600 dark:text-gray-300" />
            ) : (
                <Volume2 className="w-5 h-5 text-gray-600 dark:text-gray-300" />
            )}
        </button>
    );
}